import{dew}from"lib/public/colors.js";const exports=dew();export default exports;var _$__esModule=exports['__esModule'];export{_$__esModule as __esModule}